import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@alice-financial/pretext-ui'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import * as React from 'react'
import { useOrg } from '../../organization/useOrg'
import { WorkLocationList } from '../../workLocations/WorkLocationList'

export const WorkLocationsStepTitle = 'Work Locations'

export const WorkLocationsDescription = () => (
  <Typography variant="body2" color="text.secondary">
    Set up your company work locations
  </Typography>
)

// Wrapper component that uses the core work locations components
export const WorkLocationsComponent = () => {
  const org = useOrg()

  if (!org) return null

  return (
    <>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Tell us about the locations where your staff works. We will use this information when we create
        enrollment messages.
      </Typography>
      <WorkLocationList org={org} />
    </>
  )
}

export const WorkLocationsInstructions = () => (
  <>
    <Typography variant="subtitle1" fontWeight="bold">
      Requirements
    </Typography>
    <List dense>
      <ListItem disableGutters>
        <ListItemIcon>
          <CheckCircleOutlineIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText primary="Assign pay groups to locations" />
      </ListItem>
      <ListItem disableGutters>
        <ListItemIcon>
          <CheckCircleOutlineIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText primary="Upload logos for each location" />
      </ListItem>
    </List>
  </>
)
